<template>
  <div class="student-page-wrapper">
    <!-- Header - Use StudentHeader for students -->
    <StudentHeader />

    <!-- Main Content -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8 pt-44">
      <!-- Page Title and Back Button -->
      <div class="mb-8 flex items-center justify-center w-full">
        <div class="flex items-center gap-10 justify-center">
          <!-- Back Button -->
          <button
            @click="$router.go(-1)"
            class="w-15 h-15 bg-white border-3 border-black rounded-full flex items-center justify-center cursor-pointer shadow-none text-black transition-all duration-300 ease-in-out hover:transform hover:translate-y-[-2px] hover:shadow-[0_4px_8px_rgba(0,0,0,0.1)] flex-shrink-0"
            style="width: 60px; height: 60px; border: 3px solid #000000"
          >
            <svg
              class="w-8 h-8 text-black"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <!-- Title Content -->
          <div class="text-center">
            <h1 class="text-4xl font-extrabold text-gray-900">AI-Generated Study Material</h1>
            <p class="text-lg text-black mt-2">
              Your personalized study content has been successfully generated.
            </p>
          </div>
        </div>
      </div>

      <AIGeneratedStudyMaterial />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import StudentHeader from "@/components/StudentHeader.vue";
import AIGeneratedStudyMaterial from "@/components/Student/AIGeneratedStudyMaterial.vue";
import { logDebug } from "@/utils/secureLogger";

onMounted(() => {
  logDebug("AI Generated Study Material view mounted");
});
</script>

<style scoped>
.student-page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: url("/student-reg-bg.png") center top/100% auto no-repeat;
  background-attachment: fixed;
  position: relative;
  width: 100%;
}
</style>
